/**
 * Rótulo da observação de uma entrada do histórico da proposta.
 *
 * Numa recusa a observação é o motivo: "Motivo da recusa" ou, quando a
 * proposta já tinha sido aceite (o botão diz "Cancelar"), "Motivo do
 * cancelamento". O histórico vem do mais recente para o mais antigo, por isso
 * a entrada anterior é a seguinte na lista. Nas restantes entradas fica "Obs".
 */
const ACCEPTED_FLOW_STATUSES = ["Accepted", "Reserved", "Sale Agreement"];

export function proposalHistoryObsLabelKey(
  entry: any,
  history: any[] | null | undefined,
): string {
  if (entry?.proposalStatusCode !== "Declined") {
    return "t-proposals.t-obs";
  }
  const list = Array.isArray(history) ? history : [];
  const index = list.indexOf(entry);
  const previous = index >= 0 ? list[index + 1] : null;
  return ACCEPTED_FLOW_STATUSES.includes(previous?.proposalStatusCode ?? "")
    ? "t-proposals.t-cancel-reason"
    : "t-proposals.t-refuse-reason";
}
